import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Button from 'primevue/button';

import { useDownloadCalculationSummaryCsv } from '@/composables/useDownloadCalculationSummaryCsv';


export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadCalculationSummaryCsv',
  setup(__props) {

const { downloadCalculationSummaryCsv, hasRows } = useDownloadCalculationSummaryCsv();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    class: "font-semibold",
    severity: "secondary",
    outlined: "",
    size: "small",
    disabled: !_unref(hasRows),
    onClick: _unref(downloadCalculationSummaryCsv)
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("i", { class: "pi pi-download" }, null, -1),
      _createTextVNode(" Zapisz podsumowanie do CSV ")
    ])),
    _: 1
  }, 8, ["disabled", "onClick"]))
}
}

})